import api from './api'

const programsBasePath = '/api/v1/program'

export async function listPrograms() {
  const resp = await api.get(`${programsBasePath}`)
  return resp.data
}

export async function reorderPrograms(list) {
  const resp = await api.patch(`${programsBasePath}/reorder`, list)
  return resp.data
}

export async function createProgram(program) {
  const resp = await api.post(programsBasePath, program)
  return resp.data
}

export async function editProgram(program, id) {
  const resp = await api.patch(`${programsBasePath}/${id}`, program)
  return resp.data
}

export async function getProgram(id) {
  const resp = await api.get(`${programsBasePath}/${id}`)
  return resp.data
}

export async function deleteProgram(id) {
  const resp = await api.delete(`${programsBasePath}/${id}`)
  return resp.data
}
